module.exports = __webpack_public_path__ + "img/partyMiddle1.66bb8b57.jpg";